import { useAlert } from "@prismicio/editor-ui"
import { useEffect } from "react"
import { type To, useNavigate } from "react-router-dom"

export interface UseRedirectOptions {
  to: To
  title: string
  subtitle: string
}

export function useRedirect(condition: boolean, options: UseRedirectOptions) {
  const { to, title, subtitle } = options

  const { showAlert } = useAlert()
  const navigate = useNavigate()

  useEffect(() => {
    if (condition) {
      showAlert({ title, subtitle })
      navigate(to, { replace: true })
    }
  }, [condition, showAlert, title, subtitle, navigate, to])

  return condition
}
